var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.424,
    height: 167,
    viewBox: "0 0 132.424 167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#deb89a;}.b{fill:#794832;}.c{fill:#e74444;}.d{fill:#d81212;}.e{fill:#2b4d66;}.f{fill:#c2c5c6;}.g{fill:#6a7073;}.h{fill:#ac0101;}.i{fill:#f5cbaa;}.j{fill:#93573d;}.k{fill:#4caf50;}.l{fill:#339137;}.m{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126 -54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(126 54)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M264,192h11.515v25.909H264Z",
    transform: "translate(-194.909 -131.546)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M309.424,60.306V47.03A23.03,23.03,0,0,0,286.394,24h-2.879A11.515,11.515,0,0,0,272,35.515V52.788a34.545,34.545,0,0,0,34.545,34.545h2.879c17.273,0,17.273-14.394,17.273-14.394l-7.651-1.275A11.515,11.515,0,0,1,309.424,60.306Z",
    transform: "translate(-200.03 -24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M230.03,294.061H112l22.023-35.236a23.041,23.041,0,0,1,18.313-10.792c.4-.022.81-.032,1.216-.032H166.7l5.758,5.758L178.212,248h12.44c.63,0,1.252.025,1.871.083a23.006,23.006,0,0,1,18.2,11.655Z",
    transform: "translate(-97.606 -167.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M230.03,294.061H112l22.023-35.236a23.038,23.038,0,0,1,18.14-10.781l.173-.011c.4-.022.81-.032,1.216-.032H166.7l5.758,5.758L178.212,248h12.44c.63,0,1.252.025,1.871.083l.241.022a23.01,23.01,0,0,1,17.96,11.634Z",
    transform: "translate(-97.606 -167.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M244.454,328H192.636L184,348.152v37.424h69.091V348.152Z",
    transform: "translate(-143.697 -218.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M332.343,279.544a2.875,2.875,0,0,1-3.584-1.929l-8.636-28.788A2.882,2.882,0,0,1,320,248h3.8c.63,0,1.252.025,1.871.083l.241.022,8.356,27.856a2.879,2.879,0,0,1-1.929,3.584Z",
    transform: "translate(-230.758 -167.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M214.427,248a2.883,2.883,0,0,1-.122.828l-8.636,28.788a2.879,2.879,0,0,1-5.513-1.655l8.374-27.917.173-.011c.4-.022.81-.032,1.216-.032Z",
    transform: "translate(-153.973 -167.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M304.712,272.235,270.107,306.84,264,321.09l14.249-6.107,34.606-34.605Z",
    transform: "translate(-194.909 -182.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M104,312h40.3v51.818H104Z",
    transform: "translate(-92.485 -208.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H11.515V11.515A5.758,5.758,0,1,1,0,11.515Z",
    transform: "translate(11.515 126.667) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M136,312h17.273v5.758a5.758,5.758,0,0,1-5.758,5.758h-5.758A5.758,5.758,0,0,1,136,317.758Z",
    transform: "translate(-112.97 -208.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M354.888,347.882,380.3,358l-2.173,15.208a5.758,5.758,0,0,1-5.7,4.943H357.272l-10.527-22.127Z",
    transform: "translate(-247.879 -231.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M0,0H11.515V48.939H0Z",
    transform: "translate(109.803 89.302) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M5.758,0a5.758,5.758,0,0,1,5.758,5.758v5.758H0V5.758A5.758,5.758,0,0,1,5.758,0Z",
    transform: "translate(115.906 83.195) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 23.03,
    height: 17.273,
    rx: 8.636,
    transform: "translate(92.964 97.998) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M224,104h40.3v23.03A17.273,17.273,0,0,1,247.03,144.3h-5.758A17.273,17.273,0,0,1,224,127.03Z",
    transform: "translate(-169.303 -75.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M244.209,253.758l-5.758,8.636L224.09,248.032c.4-.022.81-.032,1.216-.032h13.145Z",
    transform: "translate(-169.361 -167.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M300.069,248.083l-14.311,14.311L280,253.758,285.758,248H298.2C298.827,248,299.45,248.025,300.069,248.083Z",
    transform: "translate(-205.152 -167.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M262.061,81.273V98.545l-5.358-.669h0c-13.7-3.5-20.547-19.482-20.547-19.482S230.394,92.788,216,92.788V81.273A17.273,17.273,0,0,1,233.273,64h11.515A17.273,17.273,0,0,1,262.061,81.273Z",
    transform: "translate(-164.182 -49.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M8.636,0H18.712A4.318,4.318,0,0,1,23.03,4.318V17.273H8.636A8.636,8.636,0,1,1,8.636,0Z",
    transform: "translate(23.03 138.182) rotate(180)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 21.026,
    cy: 20.066,
    rx: 21.026,
    ry: 20.066,
    transform: "translate(210.34 180.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M243.335,128.917a22.257,22.257,0,0,0-2.335.124c10.642,1.135,18.69,9.722,18.69,19.942s-8.048,18.807-18.69,19.942a22.244,22.244,0,0,0,2.335.124c11.612,0,21.026-8.984,21.026-20.066s-9.413-20.066-21.026-20.066Z",
    transform: "translate(-11.969 51.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M10.868,13.884a1.831,1.831,0,0,0-2.38,0,1.387,1.387,0,0,0,0,2.121l5.027,4.48a1.787,1.787,0,0,0,1.19.433,1.765,1.765,0,0,0,1.207-.508L27.642,8.463a1.382,1.382,0,0,0-.2-2.058,1.826,1.826,0,0,0-2.316.087L14.706,17.244Z",
    transform: "translate(212.998 188.137)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus7);
export default __webpack_public_path__ + "static/media/status-7.25b2c28340b2398664e99af18afcc479.svg";
export { ForwardRef as ReactComponent };